import React, { useEffect } from 'react'
import AppRouter from './router/AppRouter'
import toast, { Toaster } from 'react-hot-toast'
import { getCookie } from './services/http-common'
import OrganizationsContextProvider from './context/OrganizationsContext'
import { QueryCache, QueryClient, QueryClientProvider } from 'react-query'
import { AuthProvider } from './context/AuthContext'

const App = () => {
  const handleError = (error: any): string => {
    let errorMessage = ''
    const response = error.response
    const data = response?.data
    const status = response?.status
    if (status === 404) {
      errorMessage = data?.message ?? 'Resource not found'
    } else if (status === 403) {
      errorMessage = 'Unauthorized request'
    } else if (error.code === 'ERR_NETWORK') {
      errorMessage = ''
    } else {
      errorMessage = data?.errorMessage ?? 'An error occurred!'
    }
    return errorMessage
  }

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
      },
      mutations: {
        onError: (error) => {
          const errorMessage = handleError(error)
          if (!errorMessage) return
          toast.error(errorMessage)
        },
      },
    },
    queryCache: new QueryCache({
      onError: (error) => {
        const errorMessage = handleError(error)
        if (!errorMessage) return
        toast.error(errorMessage)
      },
    }),
  })

  useEffect(() => {
    const interval = setInterval(() => {
      if (getCookie('refreshOrganization') === 'true') {
        document.cookie = `refreshOrganization=false; path=/; max-age=0; domain=.sistemiv.com`
        window.location.reload()
      }
    }, 1000)

    return () => clearInterval(interval)
  })

  return (
    <AuthProvider>
      <OrganizationsContextProvider>
        <QueryClientProvider client={queryClient}>
          <AppRouter />
          <Toaster position='bottom-right' reverseOrder={false} />
          {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        </QueryClientProvider>
      </OrganizationsContextProvider>
    </AuthProvider>
  )
}

export default App
